<template>
  <div class="about">
    <div class="banner">
      <div class="fixed">
        <img class="codeimg" :src="bussData.weCharUrl" alt="">
        <div class="codeContent">
          <p>客服二维码</p>
        </div>
      </div>
      <img class="img" src="../../assets/images/home/about.png" alt="">
    </div>
    <div class="container">
      <div class="left">
        <p>地址：{{bussData.address}}</p>
        <p>联系电话：{{bussData.phone}}</p>
        <p>邮编：{{bussData.zipCode}}</p>
        <p>官网：{{bussData.website}}</p>
        <p>邮箱：{{bussData.email}}</p>
      </div>
      <div class="center">
        <p>微博：{{bussData.weibo}}</p>
        <p>QQ：{{bussData.qq}}</p>
      </div>
      <!-- <div class="right">
        <p @click="chat">点击进入人工在线</p>
      </div> -->
    </div>
  </div>
</template>

<script>
import {reqAbout, reqCarousel} from '../../api/index'
export default {
  data () {
    return {
      bussData: []
    }
  },
  created() {
    this.getAbout()
  },
  methods: {
    getAbout() {
      reqAbout().then(res => {
        console.log(res)
        if (res.code === 200) {
          this.bussData = res.data.bussData
        }
      })
    },
    chat() {
      var _hmt = _hmt || [];
      (function() {
        let hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?d61ce9953c9f58c32ea6b180b381c082";
        let s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
      })()
    }
  }
}
</script>

<style scoped lang="less" type="text/less">
.about{
  .banner{
    .img{
      width: 100%;
      height: 400px;
    }
    .fixed{
      position: absolute;
      top: 204px;
      right: 365px;
      width: 197px;
      height: 259px;
      background: #fff;
      border:1px solid #ccc;
      box-sizing: border-box;
      .codeimg{
        display: block;
        width: 197px;
        height: 197px;
        background: #eee;
      }
      .codeContent{
        p{
          font-weight: 700;
          font-size: 14px;
          margin-bottom: 10px;
          text-align: center;
          margin-top:13px;
          color: #040000;
        }
      }
    }

  }
  .container{
    display: flex;
    justify-content: space-around;
    margin-top:41px;
    font-size: 16px;
    p{
      margin-bottom: 30px;
    }
    .right{
      p{
        color:#463EF2;
        cursor: pointer;
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Home/About.vue